export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-text-color-540ec12b56ac85b8e7baccbfeb7d0a2f.svg";